import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser, User } from '../context/UserContext';
import Navbar from '../components/navbar';


const Checkout = () => {
    const { user } = useUser();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(window.location.search);
    const plan = queryParams.get('plan') || 'Basic';

    if (!user) {
        return (
            <div className="flex items-center justify-center h-screen">
                <h1 className="text-2xl font-bold">Session expired. Write "home" on our whatsapp to refresh it</h1>
            </div>
        );
    }

    return (
        <>
            <section className="w-full bg-pf-bgDarker relative h-[100vh] flex flex-col items-center justify-center">
                <div className="bg-white rounded-3xl shadow-2xl w-full max-w-5xl flex flex-col items-center justify-center px-10 py-20 min-h-[80vh]">
                    <h1 className="text-4xl font-bold text-gray-800 mb-8">Checkout</h1>
                    <h1 className="text-2xl font-bold">Plan: {plan}</h1>
                    <h1 className="text-2xl font-bold">User: {user.uid}</h1>
                </div>
            </section>
        </>
    );
};

export default Checkout;